import React, { useEffect, useState } from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  Container,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Button,
  Paper,
  List,
  ListItem,
  ListItemText,
  Box,
  Divider,
  Tooltip,
  IconButton,
  LinearProgress,
  Collapse,
  CssBaseline,
  useTheme,
  TextField,
  InputAdornment,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TableContainer,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { Stomp } from "@stomp/stompjs";
import SockJS from "sockjs-client";
import OrderTrackingDialog from "./OrderTrackingDialog";
import CancelIcon from "@mui/icons-material/Cancel";
import VisibilityIcon from "@mui/icons-material/Visibility";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import ShoppingBagIcon from "@mui/icons-material/ShoppingBag";
import axios from "axios";
import { createTheme, ThemeProvider, useMediaQuery } from "@mui/material";
import Brightness4Icon from "@mui/icons-material/Brightness4";
import Brightness7Icon from "@mui/icons-material/Brightness7";
import InvoicePopup from "../Reports/ViewInvoicePopup";
import DescriptionIcon from "@mui/icons-material/Description"; // ✅ Use Receipt-like icon
import Header2 from "../../Component/Header2";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import EditIcon from "@mui/icons-material/Edit";
import Header3 from "../../Component/Header3";
const MyOrders = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [mobileOpen, setMobileOpen] = useState(false);
  const [orders, setOrders] = useState([]);
  const [trackingOrder, setTrackingOrder] = useState(null);
  const [expandedOrderId, setExpandedOrderId] = useState(null);
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const prefersDarkMode = useMediaQuery("(prefers-color-scheme: dark)");
  const [darkMode, setDarkMode] = useState(prefersDarkMode);
  const [selectedInvoice, setSelectedInvoice] = useState(null);
  const [openInvoicePopup, setOpenInvoicePopup] = useState(false);
  const [searchQuery, setSearchQuery] = useState();
  const [confirmCancel, setConfirmCancel] = useState({
    open: false,
    orderId: null,
  });
  const [item, setitem] = useState();
  useEffect(() => {
    const customerId = localStorage.getItem("customerId");
    console.log(
      "Fetching orders for customerID:",
      localStorage.getItem("customerId"),
    );
    if (customerId) {
      fetchOrders(customerId);
    }

    const socket = new SockJS("https://sakhisshop.com/ws-orders");
    const stomp = Stomp.over(socket);
    stomp.connect({}, () => {
      stomp.subscribe("/topic/order-status", (message) => {
        const updatedOrder = JSON.parse(message.body);
        setOrders((prevOrders) =>
          prevOrders.map((order) =>
            order.orderId === updatedOrder.orderId ? updatedOrder : order,
          ),
        );
      });
    });

    return () => stomp.disconnect();
  }, []);

  const fetchOrders = async (customerId) => {
    try {
      const response = await axios.get(
        `https://sakhisshop.com/api/orders/my-orders/${customerId}`,
      );

      if (response.status === 200) {
        // ✅ Step 1: Show latest order first
        const ordersData = response.data.reverse();

        // ✅ Step 2: Define status priority (same as your dropdown)
        const statusOrder = {
          Pending: 1,
          Processing: 2,
          "Ready To Pack": 3, // ✅ FIXED: correct spelling as per backend
          ReadyToPack: 3, // optional safety
          Shipped: 4,
          Delivered: 5,
          Completed: 5, // just in case backend uses this word
          Cancelled: 6,
        };

        // ✅ Step 3: Sort by status (no other logic touched)
        const sortedOrders = [...ordersData].sort((a, b) => {
          const statusA = statusOrder[a.status] || 999;
          const statusB = statusOrder[b.status] || 999;
          return statusA - statusB;
        });

        // ✅ Step 4: Update state
        setOrders(sortedOrders);
      }
    } catch (err) {
      setError("Failed to fetch orders.");
    }
  };
  const handleToggleExpand = (orderId) => {
    setExpandedOrderId(expandedOrderId === orderId ? null : orderId);
  };

  const handleCancelOrder = async (orderId) => {
    try {
      await axios.put(`https://sakhisshop.com/api/orders/cancel/${orderId}`);
      // 2. ✅ Locally update the order's status in state
      setOrders((prevOrders) =>
        prevOrders.map((order) =>
          order.orderId === orderId ? { ...order, status: "Cancelled" } : order,
        ),
      );
      alert("Order Cancelled Successfully");
      fetchOrders(localStorage.getItem("userId"));
    } catch {
      alert("Failed to Cancel Order");
    }
  };

  //invoice hanlde popoup API
  const handleViewInvoice = async (order) => {
    try {
      const { data } = await axios.get(
        `https://sakhisshop.com/api/invoice/${order.orderId}`,
      );
      setSelectedInvoice({ ...data, status: order.status }); // ✅ include status
      setOpenInvoicePopup(true);
    } catch (e) {
      console.error("Error generating invoice:", error);
    }
  };

  const getProgressValue = (status) => {
    switch (status) {
      case "Pending":
        return 10;
      case "Accepted":
        return 20;
      case "Processing":
        return 40;
      case "ReadyToPack":
        return 60;
      case "Shipped":
        return 90;
      case "Delivered":
        return 100;
      default:
        return 0;
    }
  };

  //   //edit order for custoemrs
  //   const handleEditOrder = (order) => {
  //   // You can navigate or open a modal here
  //   console.log("Editing order:", order);
  //   navigate(`/edit-order/${order.orderId}`);
  // };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        minHeight: "100vh",
        pb: 8,
      }}
    >
      <CssBaseline />
      <Header3 />

      {/* Scrollable Main Content */}
      <Box
        component="main"
        sx={{
          flex: 1,
          overflow: "auto",
          p: 10,
          px: { xs: 2, sm: 6, md: 10 }, // responsive padding
          backgroundColor: "#f0f2f5",
          background: "linear-gradient(to right, #f0f4c3, #e3f2fd)",
        }}
      >
        <Container maxWidth="lg">
          <Box
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            bgcolor="#3d5a80"
            color="white"
            borderRadius={1}
            p={2}
            mb={3}
          >
            <Box
              display="flex"
              flexDirection={{ xs: "column", sm: "row" }}
              alignItems={{ xs: "stretch", sm: "center" }}
              justifyContent="space-between"
              width="100%"
              gap={2}
            >
              {/* Left: My Orders + Icon */}
              <Box display="flex" alignItems="center" gap={1}>
                <IconButton onClick={() => navigate(-1)} color="warning">
                  <ArrowBackIosNewIcon />
                </IconButton>
                <ShoppingBagIcon />
                <Typography
                  variant="h6"
                  fontFamily="Poppins"
                  sx={{ color: "white", fontWeight: "bold" }}
                >
                  My Orders
                </Typography>
              </Box>

              {/* Right: Search Field */}
              <TextField
                variant="outlined"
                size="small"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <VisibilityIcon />
                    </InputAdornment>
                  ),
                  style: { backgroundColor: "white" },
                }}
                sx={{
                  width: { xs: "100%", sm: 350 },
                }}
              />
            </Box>
          </Box>

          <Box sx={{ width: "100%", overflowX: "auto", mt: 2 }}>
            <Table stickyHeader sx={{ minWidth: 900 }}>
              <TableHead>
                <TableRow>
                  <TableCell>
                    <strong>Order ID</strong>
                  </TableCell>
                  <TableCell>
                    <strong>Order Date</strong>
                  </TableCell>{" "}
                  {/* ✅ New column */}
                  <TableCell>
                    <strong>Order Items</strong>
                  </TableCell>
                  <TableCell>
                    <strong>Total Amount</strong>
                  </TableCell>
                  <TableCell>
                    <strong>Status</strong>
                  </TableCell>
                  <TableCell>
                    <strong>Track</strong>
                  </TableCell>
                  <TableCell>
                    <strong>Action</strong>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {(orders.length === 0
                  ? []
                  : orders.filter((order) => {
                      const query = (searchQuery || "").toLowerCase();
                      const orderIdMatch = order.orderId
                        ?.toLowerCase()
                        .includes(query);
                      const itemMatch = order.orderItems?.some((item) =>
                        item.productName?.toLowerCase().includes(query),
                      );
                      return orderIdMatch || itemMatch;
                    })
                ).length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={6}>No matching orders found.</TableCell>
                  </TableRow>
                ) : (
                  orders
                    .filter((order) => {
                      const query = (searchQuery || "").toLowerCase();
                      const orderIdMatch = order.orderId
                        ?.toLowerCase()
                        .includes(query);
                      const itemMatch = order.orderItems?.some((item) =>
                        item.productName?.toLowerCase().includes(query),
                      );
                      return orderIdMatch || itemMatch;
                    })
                    .map((order) => (
                      <React.Fragment key={order.orderId}>
                        <TableRow
                          hover
                          sx={{
                            ...(order.status === "Delivered" && {
                              opacity: 0.6,
                              backgroundColor: "#e0f7fa",
                            }),
                          }}
                        >
                          <TableCell>{order.orderId}</TableCell>
                          <TableCell>
                            {order.orderDate
                              ? new Date(order.orderDate).toLocaleDateString(
                                  "en-IN",
                                  {
                                    day: "2-digit",
                                    month: "2-digit",
                                    year: "numeric",
                                  },
                                )
                              : "N/A"}
                          </TableCell>

                          <TableCell>
                            <Tooltip title="View Items">
                              <IconButton
                                color="primary"
                                onClick={() =>
                                  handleToggleExpand(order.orderId)
                                }
                              >
                                <VisibilityIcon />
                              </IconButton>
                            </Tooltip>
                          </TableCell>
                          <TableCell>
                            ₹ {order.totalAmount?.toFixed(2)}
                          </TableCell>
                          <TableCell>
                            <Typography
                              sx={{
                                color:
                                  order.status === "Delivered"
                                    ? "green"
                                    : order.status === "Cancelled"
                                      ? "red"
                                      : order.status === "ReadyToPack"
                                        ? "blue"
                                        : "orange",
                                fontWeight: "bold",
                              }}
                            >
                              {order.status === "Delivered"
                                ? "Completed"
                                : order.status}
                            </Typography>

                            {/* ✅ Add this below */}
                            <getProgressValue status={order.status} />
                            <LinearProgress
                              variant="determinate"
                              value={getProgressValue(order.status)}
                              sx={{
                                height: 6,
                                borderRadius: 2,
                                mt: 1,
                                backgroundColor: "#ddd",
                                "& .MuiLinearProgress-bar": {
                                  backgroundColor:
                                    order.status === "Delivered"
                                      ? "green"
                                      : "#1976d2",
                                },
                              }}
                            />
                          </TableCell>
                          <TableCell>
                            <Button
                              variant="outlined"
                              startIcon={<LocalShippingIcon />}
                              onClick={() => setTrackingOrder(order)}
                              disabled={order.status === "Delivered"}
                            >
                              {order.status === "Delivered"
                                ? "Delivered"
                                : "Track"}
                            </Button>
                          </TableCell>
                          <TableCell>
                            {(order.status === "Pending" ||
                              order.status === "Processing") && (
                              <Tooltip title="Edit Order">
                                <IconButton
                                  color="secondary"
                                  // onClick={() => handleEditOrder(order)}
                                ></IconButton>
                              </Tooltip>
                            )}
                            {order.status === "Pending" && (
                              <>
                                <Tooltip title="Cancel Order">
                                  <IconButton
                                    color="error"
                                    onClick={() =>
                                      setConfirmCancel({
                                        open: true,
                                        orderId: order.orderId,
                                      })
                                    }
                                  >
                                    <CancelIcon />
                                  </IconButton>
                                </Tooltip>
                                {/* Cancel Dialog */}
                                <Dialog
                                  open={confirmCancel.open}
                                  onClose={() =>
                                    setConfirmCancel({
                                      open: false,
                                      orderId: null,
                                    })
                                  }
                                >
                                  <DialogTitle>
                                    Confirm Cancellation
                                  </DialogTitle>
                                  <DialogContent>
                                    <Typography>
                                      Are you sure you want to cancel this
                                      order?
                                    </Typography>
                                  </DialogContent>
                                  <DialogActions>
                                    <Button
                                      onClick={() =>
                                        setConfirmCancel({
                                          open: false,
                                          orderId: null,
                                        })
                                      }
                                    >
                                      No
                                    </Button>
                                    <Button
                                      color="error"
                                      variant="contained"
                                      onClick={() => {
                                        handleCancelOrder(
                                          confirmCancel.orderId,
                                        );
                                        setConfirmCancel({
                                          open: false,
                                          orderId: null,
                                        });
                                      }}
                                    >
                                      Yes, Cancel Order
                                    </Button>
                                  </DialogActions>
                                </Dialog>
                              </>
                            )}

                            {/* ✅ Always show Invoice button for every status */}
                            <Tooltip title="View Invoice">
                              <IconButton
                                onClick={() => handleViewInvoice(order)}
                              >
                                <DescriptionIcon color="primary" />
                              </IconButton>
                            </Tooltip>
                            <InvoicePopup
                              openInvoicePopup={openInvoicePopup}
                              handleClose={() => setOpenInvoicePopup(false)}
                              invoice={selectedInvoice}
                            />
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell colSpan={6} sx={{ pb: 0, pt: 0 }}>
                            <Collapse
                              in={expandedOrderId === order.orderId}
                              timeout="auto"
                              unmountOnExit
                            >
                              <Box
                                sx={{
                                  margin: 1,
                                  backgroundColor: "#f9f9f9",
                                  borderRadius: 2,
                                  p: 2,
                                }}
                              >
                                <Typography variant="subtitle1" gutterBottom>
                                  Items:
                                </Typography>
                                <Divider />
                                <List dense>
                                  {order.orderItems.map((item, index) => {
                                    const unit = item?.unit || "kg";
                                    const quantity = item?.quantity ?? 0;
                                    const mrp = item?.mrp ?? 0;
                                    const price = quantity * mrp;
                                    //
                                    return (
                                      <ListItem key={index}>
                                        <ListItemText
                                          primary={`${item?.productName || "Unknown"} (Qty: ${item?.quantity}${item?.uom})`}
                                          secondary={`Price: ₹${item?.amount?.toFixed(2)}`}
                                        />
                                      </ListItem>
                                    );
                                  })}
                                </List>
                              </Box>
                            </Collapse>
                          </TableCell>
                        </TableRow>
                      </React.Fragment>
                    ))
                )}
              </TableBody>
            </Table>
          </Box>
          {/* 
          </Paper>  */}

          {/* Tracking Dialog */}
          <OrderTrackingDialog
            trackingOrder={trackingOrder}
            onClose={() => setTrackingOrder(null)}
          />
        </Container>
      </Box>

      {/* Footer */}
      {/* <ResponsiveFooter /> */}
    </Box>
  );
};

export default MyOrders;
